(function () {

  angular
    .module('meanApp')
    .directive('customOnChange', function() {
        return {
          //scope : true,
          restrict: 'A',
          //controller: 'profileCtrl as vm',
          link: function (scope, element, attrs) {
            console.log('in the custon on change input directive');
            console.log(scope);
            console.log(element);
            console.log(attrs);

            var onChangeHandler = scope.$eval(attrs.customOnChange);
            //TODO faire le base64 ici et changer directement le dom de l'image ??? non ce nest pas possible
            //element.bind('change', onChangeHandler);
            element.bind('change', function(event) {
              var that = this, 
              files = event.target.files,
              reader = new FileReader();

              reader.onload = function (event) {
                var imageSource = event.target.result,
                img = new Image();
                img.onload = function() {
                  //TODO do post treatment here and get the file data source here :) so no callback is called
                  scope.$apply(function() {
                    onChangeHandler(imageSource, img.width, img.height);
                    //that.value = null;
                  });
                };
                img.src = imageSource;
              };

              reader.readAsDataURL(files[0]);
              
            });
          }
        };
      });

})();

